import React from 'react';
import { MenuItem, Select } from '@mui/material';
import useUserProfile from '../../../../../customHooks/useUserProfile';
import { useZinantisMembers } from '../../../../contextsProperty/ContextZinantisMembers';
import Icon from '../../../../../muiComponents/Icon';
import { MembersFilters } from '../../../../../types/zinantis/members/membersType';

interface OptionState {
    label: string;
    icon: string;
    iconClassName: string;
    value: MembersFilters['connected'];
}

const ConnectedFilter = () => {
    const { translate } = useUserProfile();
    const { updateFilters, filters } = useZinantisMembers();
    const selectStyles = {
        padding: '0 10px',
        width: '100%',

        '&::before, &::after': {
            borderBottom: 'none',
        },
        '&:hover::before': {
            borderBottom: 'none !important',
        },
        '& .MuiSelect-select': {
            paddingLeft: 0,
            display: 'flex',
            alignItems: 'center',
        },
        '& .MuiSelect-select:focus': {
            backgroundColor: 'transparent',
        },
        '& .Mui-focused .MuiSelect-select': {
            backgroundColor: 'transparent',
        },
        '& .MuiInputBase-root.Mui-focused': {
            backgroundColor: 'transparent',
        },
    };

    const options: OptionState[] = [
        {
            label: translate('all'),
            icon: '',
            iconClassName: '',
            value: 'all',
        },
        {
            label: translate('connected'),
            icon: 'CheckCircle',
            iconClassName: 'member-icon__connected',
            value: 'connected',
        },
        {
            label: translate('disconnected'),
            icon: 'CircleOutlined',
            iconClassName: 'member-icon__disconnected',
            value: 'disconnected',
        },
    ];

    return (
        <Select
            className='card-component'
            variant='standard'
            placeholder={translate('connected')}
            sx={selectStyles}
            value={filters.connected}
        >
            {options.map((option: OptionState) => (
                <MenuItem
                    component='li'
                    key={option.label}
                    onClick={() => {
                        updateFilters('connected', option.value);
                    }}
                    value={option.value}
                >
                    <Icon
                        iconName={option.icon}
                        className={option.iconClassName}
                    />
                    <p className='margin-inline10'>{option.label}</p>
                </MenuItem>
            ))}
        </Select>
    );
};

export default ConnectedFilter;
